import { Link } from "react-router-dom";

export default function CTASection() {
    return (
        <section className="relative py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">

            {/* Background Gradient */}
            <div className="absolute inset-0 bg-gradient-to-r from-teal-500 via-cyan-500 to-blue-600 opacity-95"></div>

            {/* Glow Effect */}
            <div className="absolute -top-10 -left-10 w-48 sm:w-64 lg:w-72 h-48 sm:h-64 lg:h-72 bg-white/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -right-10 w-48 sm:w-64 lg:w-72 h-48 sm:h-64 lg:h-72 bg-white/10 rounded-full blur-3xl"></div>

            {/* Content */}
            <div className="relative max-w-5xl mx-auto text-center text-white">

                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                    Ready to Book Your Dream Stay?
                </h2>

                <p className="text-sm sm:text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-8 px-2">
                    Discover luxury hotels, exclusive deals, and unforgettable experiences
                    across top destinations. Your perfect trip starts here.
                </p>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">

                    <Link
                        to="/hotels"
                        className="px-5 sm:px-6 py-3 rounded-full bg-white text-teal-600 font-semibold 
                        shadow-lg hover:scale-105 hover:shadow-xl transition duration-300 text-sm sm:text-base"
                    >
                        Explore Hotels
                    </Link>

                    <Link
                        to="/contact-us"
                        className="px-5 sm:px-6 py-3 rounded-full border border-white text-white 
                        font-semibold hover:bg-white hover:text-teal-600 
                        transition duration-300 text-sm sm:text-base"
                    >
                        Contact Us
                    </Link>

                </div>

                {/* Trust Indicators */}
                <div className="mt-8 sm:mt-10 flex flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-white/80 px-2">
                    <span>✔ 500+ Hotels</span>
                    <span>✔ Best Price Guarantee</span>
                    <span>✔ 24/7 Support</span>
                </div>

            </div>
        </section>
    );
}